import $ from 'jquery';

const CartTotalUpdater = () => {
	const init = () => {
		if (!$('.cart-count').length) return;

		updateCartTotal();
	};

	const updateCartTotal = () => {
		$(document).on('submit', 'form.woocommerce-cart-form', function () {
			let total = 0;

			if ($('.input-text.qty.text').length > 0) {
				$('.input-text.qty.text').each(function () {
					total += parseFloat($(this).val()) || 0;
				});
			}

			$('.cart-count').html(total);
		});

		$(document).on('click', 'a.remove', function () {
			let total = 0;
			const own = $(this)
				.parent()
				.parent()
				.find('.input-text.qty.text')
				.val();

			if ($('.input-text.qty.text').length > 0) {
				$('.input-text.qty.text').each(function () {
					total += parseFloat($(this).val()) || 0;
				});
			}

			$('.cart-count').html(total - own);
		});
	};

	init();
};

try {
	CartTotalUpdater();
} catch (error) {
	console.error('cart total updater error : ' + error);
}
